import importerStore from '@shared/importer/importer-store';
import { PositionService } from '@modules/position/position-service';
import positionImporterFields from '@modules/position/position-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  PositionService.import,
  positionImporterFields,
  i18n('entities.position.importer.fileName'),
  i18n('entities.position.importer.hint'),
);
